export enum EngagementType {
  TimeAndMaterial = 1,
  AdHoc = 2,
  FixedPrice = 3,
}
